var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 26",
    style: {
      enableBackground: "new 0 0 24 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.4,13.1c0,2.1,0.6,4.1,1.6,5.9c0.1,0.2,0.4,0.3,0.7,0.2C2.9,19,3,18.7,2.9,18.5c-1-1.6-1.5-3.5-1.5-5.4 C1.4,7.2,6.1,2.4,12,2.4c1.5,0,3,0.3,4.3,0.9l-1,0.3C15,3.7,14.8,4,14.9,4.3c0.1,0.3,0.4,0.4,0.6,0.3L18,3.9 c0.3-0.1,0.4-0.4,0.3-0.6l-0.7-2.4c-0.1-0.3-0.3-0.4-0.6-0.3c-0.3,0.1-0.4,0.3-0.3,0.6l0.4,1.5c-1.6-0.8-3.4-1.3-5.2-1.3 C5.6,1.4,0.4,6.6,0.4,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.7c-1.5,0-3-0.3-4.4-1l1.3-0.5c0.3-0.1,0.4-0.4,0.3-0.6c-0.1-0.3-0.4-0.4-0.6-0.3c-0.1,0-2.3,0.9-2.4,1 l0,0c-0.3,0.1-0.4,0.4-0.3,0.7l0.9,2.3c0.1,0.3,0.4,0.4,0.7,0.3c0.3-0.1,0.4-0.4,0.3-0.7l-0.5-1.2c1.5,0.7,3.2,1.1,4.9,1.1 c6.4,0,11.6-5.2,11.6-11.6c0-2.1-0.6-4.1-1.6-5.9c-0.1-0.2-0.4-0.3-0.7-0.2c-0.2,0.1-0.3,0.4-0.2,0.7c1,1.6,1.5,3.5,1.5,5.4 C22.6,18.9,17.9,23.7,12,23.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.2,10.5V8.7c0-1.7-1.4-3.1-3.1-3.1c-1.7,0-3.2,1.4-3.2,3.1v1.9c-1,0.1-1.7,0.9-1.7,1.9v4.7 c0,1.1,0.9,1.9,1.9,1.9h5.9c1.1,0,1.9-0.9,1.9-1.9v-4.7C16.9,11.5,16.1,10.6,15.2,10.5z M9.8,8.7c0-1.2,1-2.1,2.2-2.1 c1.2,0,2.1,1,2.1,2.1v1.9H9.8V8.7z M15.9,17.2c0,0.5-0.4,0.9-0.9,0.9H9.1c-0.5,0-0.9-0.4-0.9-0.9v-4.7c0-0.5,0.4-0.9,0.9-0.9 c1.2,0,6,0,5.9,0c0.5,0,0.9,0.4,0.9,0.9V17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,12.5c-0.9,0-1.6,0.7-1.6,1.6c0,0.7,0.5,1.3,1.1,1.5v1c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5v-1 c0.6-0.2,1.1-0.8,1.1-1.5C13.6,13.2,12.9,12.5,12,12.5z M12,14.7c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6 c0.3,0,0.6,0.3,0.6,0.6C12.6,14.4,12.3,14.7,12,14.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.89763676f1ad9555544c0859dea8da2b.svg";
export { ForwardRef as ReactComponent };